import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';

const getStyles = () => ({
  shimmerWrapper: {
    height: '100%',
    padding: '30px 0',
    background: '#fff',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    borderRadius: '2px',
    '& .header-shimmer': {
      margin: '20px 0',
    },
    '& .option-container': {
      marginBottom: 18,
      width: 400,
      display: 'flex',
      justifyContent: 'space-between',
      '& .option-shimmer': {
        display: 'inline-block',
        width: 192,
        height: 146,
      },
    },
    '& .input-shimmer, .label-shimmer': {
      marginTop: 8,
    },
  },
  'shimmerWrapper-s': {
    '& .option-container': {
      width: 280,
      '& .option-shimmer': {
        display: 'inline-block',
        width: 132,
        height: 146,
      },
    },
  },
});

export const WebsiteStepShimmer = () => {
  const classes = useDefaultStyles(getStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const isSmallSize = displayMode === 's';

  const optionShimmer = useMemo(() => (
    <div className="option-shimmer">
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '146px', width: isSmallSize ? '132px' : '192px' }} /> </Skeleton>
    </div>
  ), [isSmallSize]);

  return (
    <div className={classNames('shimmer-wrapper', classes.shimmerWrapper, classes[`shimmerWrapper-${displayMode}`])}>
      <div className="icon-shimmer">
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '44px', width: '50px' }} /> </Skeleton>
      </div>
      <div className="header-shimmer">
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '22px', width: isSmallSize ? '200px' : '244px' }} /> </Skeleton>
      </div>
      <div className="option-container">
        {optionShimmer}
        {optionShimmer}
      </div>
      <div className="label-shimmer">
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '21px', width: isSmallSize ? '240px' : '360px' }} /> </Skeleton>
      </div>
      <div className="input-shimmer">
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '40px', width: isSmallSize ? '240px' : '360px' }} /> </Skeleton>
      </div>
    </div>
  );
};
